import axios, { AxiosResponse } from 'axios'
const server = process.env.REACT_APP_SERVER_URL

/**
   Callback que se ejecuta cuando abadonas el input de document y hacer la peticion.
 * @param {String} useType Tipo del modal ('create', 'edit')
 * @param {String} document valor del input de documento
 * @param {String} documentType valor del input de documentoType
 * @param {String} pageSize valor del tamaño de pagina.
 * @param {String} url URL al cual hace la peticion.
 * @param {String} type tipo (clients|providers)
 * @returns Promise<boolean|undefined>
 */
export const onCheckCb = async (
  useType: string,
  document: string,
  documentType: string,
  pageSize: number,
  url: string,
  type: string
): Promise<boolean | undefined> => {
  if (useType === 'create') {
    const response: AxiosResponse<any> = await axios.get(
      `${server}${url}${[
        `document=${document}`,
        `documentType=${documentType}`,
        ...['pageNumber=1', `pageSize=${pageSize}`],
      ].join('&')}`
    )
    return response.data[type].some(
      (value) => value.document.document === document
    )
  }
}
